import PubSub from '../PubSub';

const ANALYTICS_PREFIX = 'analytics';

export const sendAnalytics = (eventName, payload, prefix = ANALYTICS_PREFIX) => {
    const trigger = `${prefix}:${eventName}`;
    PubSub.publish(trigger, payload);
};
